import React from 'react';
import { Image, ImageProps } from '@zeal/web-ui';
import { useDashboardBranding } from '@modules/Shared/Components/Branded/useDashboardBranding';
import { useBrandingConfig } from '@app/data/Branding';

export default function TitleImage(props: ImageProps) {
	const { isLoading } = useBrandingConfig();
	const { logo, title } = useDashboardBranding();

	if (isLoading || !logo) {
		return <div className={props?.className} style={props?.style} />;
	}

	return <Image src={logo} alt={title} {...props} />;
}
